import { Result } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ReactComponent as NotFoundSvg } from 'assets/svgs/404.svg';
import { Page } from 'components/molecules/page';
import { ROCKETLANE_EMAILS } from 'constant';
import { useTranslation } from 'hooks/use-translation';

const StyledPage = styled(Page)`
  align-items: center;
  justify-content: center;
  .ant-result {
    max-width: 570px;
  }
`;

const supportEmail = ROCKETLANE_EMAILS.support;
const domainName = window.location.hostname;

export const AccountNotFound: FC = () => {
  const title = useTranslation('app.account.not_found.title');
  const mailSubject = useTranslation('app.account.not_found.email.subject', {
    domainName,
  });
  const mailContent = useTranslation('app.account.not_found.email.content', {
    domainName,
  });

  const SubTitle = () => (
    <>
      <FormattedMessage id="app.account.not_found.info" />
      <br />
      <FormattedMessage
        id="app.account.not_found.info_question"
        values={{
          b: (chunks) => <strong>{chunks}</strong>,
          accountLink: domainName,
        }}
      />
    </>
  );

  const SubTitleExtra = () => (
    <FormattedMessage
      id="app.account.not_found.info_extra"
      values={{
        link: (
          <a
            target="_blank"
            href={`mailto:${supportEmail}?subject=${mailSubject}&body=${mailContent}`}
            rel="noreferrer"
          >
            {supportEmail}
          </a>
        ),
      }}
    />
  );

  return (
    <StyledPage>
      <Result
        title={title}
        icon={<NotFoundSvg />}
        subTitle={<SubTitle />}
        extra={<SubTitleExtra />}
      />
    </StyledPage>
  );
};
